<template>
  <!-- Приём -->
  <v-dialog v-model="showArrivalDialog" :retain-focus="false" persistent :fullscreen="isMobile" max-width="1000px"
    :loading="isLoading">
    <v-card>
      <v-card-title :class="isMobile ? 'pt-12' : 'headline'">
        <v-row>
          <v-col cols="12" class="d-flex align-center">
            <span class="headline">{{ $t("bookings.checkout_big") }}</span>
            <v-icon class="ml-2 green--text" :disabled="damageControlBlocked" data-testid="arrival-save-icon" @click="inHome()">
              mdi-content-save-all-outline
            </v-icon>
            <v-spacer></v-spacer>
            <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
              @click="closeArrivalDialog()">
              mdi-close
            </v-icon>
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" v-if="showFines && fines.length > 0">
            <h2>{{ $t("custom.fines") }}</h2>
            <v-data-table :headers="fines_headers_small" :loading="isLoading" :loading-text="$t('custom.loading_table')"
              :items="fines" :search="search_fines" dense hide-default-footer :sort-by="['created_at']"
              :sort-desc="[true]">
              <template slot="item" slot-scope="props">
                <tr>
                  <td :class="'text-center ' + stateFineColor(props.item.state)
                    ">
                    {{ props.item.number }}
                  </td>
                  <td class="text-center" v-if="props.item.date">
                    {{ returnDate(props.item.date) }}
                  </td>
                  <td class="text-center" v-else>
                    {{ formatCreatedAtWithYear(props.item.violation_date) }}
                  </td>
                  <td class="text-center">
                    <router-link v-if="!booking.entity" :to="{ path: `/clients/${props.item.client_id}` }">{{
                      props.item.client_id }}</router-link>
                    <router-link v-else :to="{ path: `/clients/${props.item.client_id}` }">{{ props.item.client_id
                    }}</router-link>
                  </td>
                  <td class="text-center">
                    {{ props.item.sum }}
                  </td>
                  <td class="text-center description-trunc">
                    <read-more v-if="props.item.description &&
                      props.item.description.length > 0
                    " :more-str="$t('custom.read')" :text="props.item.description" link="#"
                      :less-str="$t('custom.less')" :max-chars="20"></read-more>
                  </td>
                  <!-- Состояние -->
                  <td class="text-center">
                    <v-menu absolute offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn :color="stateFineColor(props.item.state)" small block v-bind="attrs" v-on="on">
                          {{
                            props.item.state ? translateFinesState(props.item.state) : $t("fines.fresh")
                          }}
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item link v-for="(state, index) in fines_state" :key="index"
                          @click="updateFinesState(props.item.id, state.value)">
                          <v-list-item-title>
                            {{ state.text }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-divider class="mt-3 mb-3"></v-divider>
          </v-col>
          <v-col cols="12" md="4" sm="12" xs="12"
            :style="`border-right: 1px solid ${$vuetify.theme.dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'};`">
            <v-row>
              <v-col cols="12">
                <vc-date-picker v-model="booking.end_date" mode="dateTime" :model-config="calendarConfig"
                  :attributes="calendar_attributes" is24hr is-required title-position="left" class="flex d-flex md12 p-0"
                  :is-dark="$vuetify.theme.dark">
                  <template v-slot="{
                    inputValue,
                    inputEvents,
                    isDragging,
                    showPopover,
                  }">
                    <v-flex md12 :class="isMobile ? '' : 'd-flex'">
                      <v-text-field @click="showPopover" :class="isDragging
                        ? 'text-gray-600 mr-2 p-0'
                        : 'text-gray-900 mr-2 p-0'
                        " :value="inputValue" v-on="inputEvents" :label="$t('bookings.end_date_big')"
                        prepend-icon="mdi-calendar-clock" :disabled="isLoading" readonly hide-details></v-text-field>
                    </v-flex>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12" v-if="showMileage">
                <v-text-field disabled :label="$t('bookings.prev_mileage')" :value="booking.start_mileage"
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12" xs="12" v-if="showMileage">
                <v-text-field v-model.number="booking.end_mileage" :disabled="isLoading"
                  @input="checkMileageLimit(), calcExtraMileagePrice()" :label="$t('bookings.new_mileage')"
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" v-if="set_car">
                <v-text-field :label="$t('home.car_location')" v-model="set_car.store_place" :disabled="isLoading"
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="12" style="font-size: 16px" v-if="showMileage && $store.getters.getCompany &&
                $store.getters.getCompany.company &&
                ($store.getters.getCompany.company.mileage_limit > 0 ||
                  (set_car && set_car.extra_mileage_km > 0))
              ">
                <p v-if="booking.end_mileage - booking.start_mileage > 0" :class="limitExept ? 'red--text' : ''">
                  {{ $t("bookings.mileage") }}:
                  {{
                    Math.floor(
                      (booking.end_mileage - booking.start_mileage) /
                      (booking.days > 0 ? booking.days : 1)
                    )
                  }}
                  {{ $t("bookings.km_day") }}
                  <span v-if="limitExept">,
                    <br>
                    {{ $t("bookings.extra_mileage") }}:
                    {{ returnMileageExt() }} {{ $t("custom.km") }}</span>
                </p>
                <p v-if="limitCost > 0">
                  {{ $t("bookings.extra_mileage_cost") }}:
                  <span class="font-weight-bold">{{ limitCost }}</span>
                </p>
                <p v-if="limitCost > 0">
                  {{ $t("cars.extra_mileage_km_info") }}:
                  <span class="font-weight-bold">{{ Math.floor(limitCost / returnMileageExt()) }}</span>
                </p>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="booking.clean_end" :label="$t('bookings.clean_car')" :disabled="isLoading"
                  @change="calcClean()" hide-details dense></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="showFuel">
                <v-checkbox v-model="booking.gas_end_full" @click="calcGas()" :label="$t('bookings.full_tank')"
                  :disabled="isLoading" hide-details dense></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="booking.technical_check_end" :label="$t('bookings.technical_check')"
                  :disabled="isLoading" hide-details dense></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="showCleanPaid">
                <p class="font-weight-bold">
                  {{ $t("bookings.clean_paid") }}: {{ booking.clean_payment }}
                </p>
              </v-col>
              <v-col cols="12" v-if="showFuel && !booking.gas_end_full">
                <v-text-field v-model="booking.gas_end" type="text" :label="$t('bookings.lost_gas')"
                  :disabled="isLoading" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" v-if="!booking.technical_check_end">
                <v-text-field v-model="booking.technical_check_end_comment" :disabled="isLoading"
                  :label="$t('bookings.technical_check_comment')" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" v-if="company && company.damage_marking && company.damage_marking === true">
                <v-divider class="my-4"></v-divider>
            <car-damage-marker
              ref="carDamageMarker"
              v-model="booking.checkout_damages"
              mode="checkout"
              :booking-id="booking.id"
              :previous-damages="booking.checkin_damages || []"
            ></car-damage-marker>
              </v-col>
              <v-col cols="12" v-if="value && damageControlEnabled">
                <damage-control-entry :key="damageControlContext" :booking="booking" side="arrival" @blocking="onDamageControlBlocking" />
                <damage-control-strict-alert v-if="damageControlBlocked" side="arrival" :lines="damageControlReasonLines" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" v-if="hasUnsecuredDepositHold">
            <v-alert dense border="left" colored-border type="warning" icon="mdi-shield-alert-outline"
              data-testid="arrival-deposit-hold-unsecured">
              {{ $t("bookings.deposit_hold.unsecured_acceptance") }}
            </v-alert>
          </v-col>
          <!-- Разбиение залога, взятого банковским холдом: D + R + H. -->
          <v-col cols="12" md="8" v-if="hasDepositHold">
            <v-alert dense border="left" colored-border type="info" icon="mdi-shield-lock-outline"
              data-testid="arrival-deposit-hold">
              <div class="font-weight-medium mb-2">{{ $t("bookings.deposit_hold.acceptance_title") }}</div>
              <v-row v-for="(deduction, index) in depositHoldDeductions" :key="`deposit-deduction-${index}`" dense>
                <v-col cols="12" sm="4">
                  <v-select v-model="deduction.category" :items="depositHoldCategories" item-text="text"
                    item-value="value" :label="$t('bookings.deposit_hold.category')" :disabled="isLoading"
                    hide-details dense></v-select>
                </v-col>
                <v-col cols="12" sm="5">
                  <v-text-field v-model.trim="deduction.reason" :label="$t('bookings.deposit_hold.reason')"
                    :disabled="isLoading" hide-details dense></v-text-field>
                </v-col>
                <v-col cols="10" sm="2">
                  <v-text-field v-model.number="deduction.sum" type="number" min="0"
                    :label="$t('custom.amount')" :disabled="isLoading" hide-details dense></v-text-field>
                </v-col>
                <v-col cols="2" sm="1" class="d-flex align-center justify-end">
                  <v-btn icon small :disabled="isLoading" :aria-label="$t('custom.delete')"
                    @click="removeDepositHoldDeduction(index)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-btn x-small text color="primary" :disabled="isLoading" @click="addDepositHoldDeduction"
                data-testid="arrival-deposit-add-deduction">
                <v-icon x-small left>mdi-plus</v-icon>{{ $t("bookings.deposit_hold.add_deduction") }}
              </v-btn>
              <v-row dense class="mt-2">
                <v-col cols="12" sm="4">
                  <v-text-field v-model.number="depositHoldDeferred" type="number" min="0"
                    :label="$t('bookings.deposit_hold.deferred')" :disabled="isLoading" dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field v-model="depositHoldRetainUntil" type="date"
                    :label="$t('bookings.deposit_hold.retain_until')" :disabled="isLoading || depositHoldDeferred <= 0"
                    dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field :value="depositHoldReturn" :label="$t('bookings.deposit_hold.return_now')"
                    readonly dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <div v-if="depositHoldValidationError" class="error--text mt-2" role="alert"
                data-testid="arrival-deposit-error">{{ $t(depositHoldValidationError) }}</div>
            </v-alert>
          </v-col>
          <!-- <div xs12 md1 class="vl" style="margin-left: 3%"></div> -->
          <v-col cols="12" md="8" v-if="!hasDepositHold">
            <v-row>
              <v-col cols="12">
                <v-row class="pt-2">
                  <v-col auto>
                    <v-btn v-if="returnDeposit() >= 0" class="my-auto" outlined block :disabled="isLoading">
                      {{ $t("bookings.give") }}: {{ returnDeposit() }}
                    </v-btn>
                    <v-btn v-else class="my-auto" color="orange" block outlined :disabled="isLoading">
                      {{ $t("bookings.for_pay") }}: {{ returnDeposit() * -1 }}
                    </v-btn>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.deposit.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true"
                      @change="arrival_payments.deposit.currency_id = arrival_payments.deposit.company_cashbox.currency_id, arrival_payments.deposit.company_cashbox_id = arrival_payments.deposit.company_cashbox.id"
                      :label="$t('companies.currency')" class="mt-2" :disabled="isLoading" dense
                      hide-details></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Залог -->
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.deposit.type"
                      color="success" value="Наличные" :disabled="giveNullDeposit || arrival_payments.deposit.type == 'Терминал' ||
                        arrival_payments.deposit.type == 'На карту' ||
                        arrival_payments.deposit.type == 'Р/с' ||
                        arrival_payments.deposit.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.deposit.type == 'Терминал' ||
                          arrival_payments.deposit.type == 'На карту' ||
                          arrival_payments.deposit.type == 'Р/с' ||
                          arrival_payments.deposit.type == 'Баланс клиента'
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.deposit.type"
                      color="warning" value="Терминал" :disabled="giveNullDeposit || arrival_payments.deposit.type == 'Наличные' ||
                        arrival_payments.deposit.type == 'На карту' ||
                        arrival_payments.deposit.type == 'Р/с' ||
                        arrival_payments.deposit.type == 'Баланс клиента'
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.deposit.type == 'Наличные' ||
                          arrival_payments.deposit.type == 'На карту' ||
                          arrival_payments.deposit.type == 'Р/с' ||
                          arrival_payments.deposit.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.deposit.type"
                      color="info" value="На карту" :disabled="giveNullDeposit || arrival_payments.deposit.type == 'Наличные' ||
                        arrival_payments.deposit.type == 'Терминал' ||
                        arrival_payments.deposit.type == 'Р/с' ||
                        arrival_payments.deposit.type == 'Баланс клиента'
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.deposit.type == 'Наличные' ||
                          arrival_payments.deposit.type == 'Терминал' ||
                          arrival_payments.deposit.type == 'Р/с' ||
                          arrival_payments.deposit.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.deposit.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="giveNullDeposit || arrival_payments.deposit.type == 'Наличные' ||
                        arrival_payments.deposit.type == 'Терминал' ||
                        arrival_payments.deposit.type == 'На карту' ||
                        arrival_payments.deposit.type == 'Баланс клиента'
                        " :style="arrival_payments.deposit.type == 'Наличные' ||
                            arrival_payments.deposit.type == 'Терминал' ||
                            arrival_payments.deposit.type == 'На карту' ||
                            arrival_payments.deposit.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.deposit.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="giveNullDeposit || arrival_payments.deposit.type == 'Наличные' ||
                        arrival_payments.deposit.type == 'Терминал' ||
                        arrival_payments.deposit.type == 'На карту' ||
                        arrival_payments.deposit.type == 'Р/с'
                        " :style="arrival_payments.deposit.type == 'Наличные' ||
                            arrival_payments.deposit.type == 'Терминал' ||
                            arrival_payments.deposit.type == 'На карту' ||
                            arrival_payments.deposit.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="d-flex align-center justify-end">
                <v-switch v-model="giveNullDeposit" :label="$t('bookings.not_give')" :disabled="isLoading" color="error"
                  @change="giveFullDeposit = !giveNullDeposit, arrival_payments.deposit.sum = 0, arrival_payments.deposit.type = null"
                  class="my-auto" hide-details dense></v-switch>
              </v-col>
              <v-col cols="12">
                <v-divider class="mt-3 mb-2"></v-divider>
                <v-select v-model="selected_add_services" :items="visibleAddServices" item-text="text" :disabled="isLoading"
                  item-value="value" clearable :label="$t('bookings.select_add_services')" multiple
                  hide-details data-testid="arrival-add-services"></v-select>
              </v-col>
              <!-- Мойка -->
              <v-col cols="12" v-if="checkAddPayment('Мойка')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.clean.sum" :label="$t('custom.clean')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.clean.sum, arrival_payments.clean.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.clean.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.clean.currency_id = arrival_payments.clean.company_cashbox.currency_id, arrival_payments.clean.company_cashbox_id = arrival_payments.clean.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Мойка')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.clean.type"
                      color="success" value="Наличные" :disabled="arrival_payments.clean.type == 'Терминал' ||
                        arrival_payments.clean.type == 'На карту' ||
                        arrival_payments.clean.type == 'Р/с' ||
                        arrival_payments.clean.type == 'Баланс клиента'
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.clean.type == 'Терминал' ||
                          arrival_payments.clean.type == 'На карту' ||
                          arrival_payments.clean.type == 'Р/с' ||
                          arrival_payments.clean.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.clean.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.clean.type == 'Наличные' ||
                        arrival_payments.clean.type == 'На карту' ||
                        arrival_payments.clean.type == 'Р/с' ||
                        arrival_payments.clean.type == 'Баланс клиента'
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.clean.type == 'Наличные' ||
                          arrival_payments.clean.type == 'На карту' ||
                          arrival_payments.clean.type == 'Р/с' ||
                          arrival_payments.clean.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.clean.type"
                      color="info" value="На карту" :disabled="arrival_payments.clean.type == 'Наличные' ||
                        arrival_payments.clean.type == 'Терминал' ||
                        arrival_payments.clean.type == 'Р/с' ||
                        arrival_payments.clean.type == 'Баланс клиента'
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.clean.type == 'Наличные' ||
                          arrival_payments.clean.type == 'Терминал' ||
                          arrival_payments.clean.type == 'Р/с' ||
                          arrival_payments.clean.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.clean.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.clean.type == 'Наличные' ||
                        arrival_payments.clean.type == 'Терминал' ||
                        arrival_payments.clean.type == 'На карту' ||
                        arrival_payments.clean.type == 'Баланс клиента'
                        " :style="arrival_payments.clean.type == 'Наличные' ||
                            arrival_payments.clean.type == 'Терминал' ||
                            arrival_payments.clean.type == 'На карту' ||
                            arrival_payments.clean.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.clean.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.clean.type == 'Наличные' ||
                        arrival_payments.clean.type == 'Терминал' ||
                        arrival_payments.clean.type == 'На карту' ||
                        arrival_payments.clean.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.clean.type == 'Наличные' ||
                            arrival_payments.clean.type == 'Терминал' ||
                            arrival_payments.clean.type == 'На карту' ||
                            arrival_payments.clean.type == 'Р/с'
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Дополнительное время -->
              <v-col cols="12" v-if="checkAddPayment('Дополнительное время')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.additional_hours.sum"
                      :label="$t('bookings.extra_time')" :disabled="isLoading" dense
                      :messages="messageInBaseCurrency(arrival_payments.additional_hours.sum, arrival_payments.additional_hours.currency_id)"></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.additional_hours.company_cashbox"
                      :items="active_company_cashboxes" :item-text="item => item.name" :return-object="true"
                      :disabled="isLoading"
                      @change="arrival_payments.additional_hours.currency_id = arrival_payments.additional_hours.company_cashbox.currency_id, arrival_payments.additional_hours.company_cashbox_id = arrival_payments.additional_hours.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Дополнительное время')"
                class="d-flex align-center justify-space-between">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.additional_hours.type"
                      color="success" value="Наличные" :disabled="arrival_payments.additional_hours.type == 'Терминал' ||
                        arrival_payments.additional_hours.type == 'На карту' ||
                        arrival_payments.additional_hours.type == 'Р/с' ||
                        arrival_payments.additional_hours.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.additional_hours.type == 'Терминал' ||
                          arrival_payments.additional_hours.type == 'На карту' ||
                          arrival_payments.additional_hours.type == 'Р/с' ||
                          arrival_payments.additional_hours.type == 'Баланс клиента'
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment"
                      v-model="arrival_payments.additional_hours.type" color="warning" value="Терминал" :disabled="arrival_payments.additional_hours.type == 'Наличные' ||
                        arrival_payments.additional_hours.type == 'На карту' ||
                        arrival_payments.additional_hours.type == 'Р/с' ||
                        arrival_payments.additional_hours.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.additional_hours.type == 'Наличные' ||
                          arrival_payments.additional_hours.type == 'На карту' ||
                          arrival_payments.additional_hours.type == 'Р/с' ||
                          arrival_payments.additional_hours.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment"
                      v-model="arrival_payments.additional_hours.type" color="info" value="На карту" :disabled="arrival_payments.additional_hours.type == 'Наличные' ||
                        arrival_payments.additional_hours.type == 'Терминал' ||
                        arrival_payments.additional_hours.type == 'Р/с' ||
                        arrival_payments.additional_hours.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.additional_hours.type == 'Наличные' ||
                          arrival_payments.additional_hours.type == 'Терминал' ||
                          arrival_payments.additional_hours.type == 'Р/с' ||
                          arrival_payments.additional_hours.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment"
                      v-model="arrival_payments.additional_hours.type" color="secondary" class="mt-0 mr-0" dense
                      hide-details value="Р/с" :disabled="arrival_payments.additional_hours.type == 'Наличные' ||
                        arrival_payments.additional_hours.type == 'Терминал' ||
                        arrival_payments.additional_hours.type == 'На карту' ||
                        arrival_payments.additional_hours.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.additional_hours.type == 'Наличные' ||
                            arrival_payments.additional_hours.type == 'Терминал' ||
                            arrival_payments.additional_hours.type == 'На карту' ||
                            arrival_payments.additional_hours.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment"
                      v-model="arrival_payments.additional_hours.type" color="error" class="mt-0 mr-0" dense
                      hide-details value="Баланс клиента" :disabled="arrival_payments.additional_hours.type == 'Наличные' ||
                        arrival_payments.additional_hours.type == 'Терминал' ||
                        arrival_payments.additional_hours.type == 'На карту' ||
                        arrival_payments.additional_hours.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.additional_hours.type == 'Наличные' ||
                            arrival_payments.additional_hours.type == 'Терминал' ||
                            arrival_payments.additional_hours.type == 'На карту' ||
                            arrival_payments.additional_hours.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Превышение пробега -->
              <v-col cols="12" v-if="checkAddPayment('Превышение пробега')" xs12>
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.mileage.sum"
                      :label="$t('bookings.extra_mileage_big')" :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.mileage.sum, arrival_payments.mileage.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.mileage.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.mileage.currency_id = arrival_payments.mileage.company_cashbox.currency_id, arrival_payments.mileage.company_cashbox_id = arrival_payments.mileage.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Превышение пробега')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.mileage.type"
                      color="success" value="Наличные" :disabled="arrival_payments.mileage.type == 'Терминал' ||
                        arrival_payments.mileage.type == 'На карту' ||
                        arrival_payments.mileage.type == 'Р/с' ||
                        arrival_payments.mileage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.mileage.type == 'Терминал' ||
                          arrival_payments.mileage.type == 'На карту' ||
                          arrival_payments.mileage.type == 'Р/с' ||
                          arrival_payments.mileage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.mileage.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.mileage.type == 'Наличные' ||
                        arrival_payments.mileage.type == 'На карту' ||
                        arrival_payments.mileage.type == 'Р/с' ||
                        arrival_payments.mileage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.mileage.type == 'Наличные' ||
                          arrival_payments.mileage.type == 'На карту' ||
                          arrival_payments.mileage.type == 'Р/с' ||
                          arrival_payments.mileage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.mileage.type"
                      color="info" value="На карту" :disabled="arrival_payments.mileage.type == 'Наличные' ||
                        arrival_payments.mileage.type == 'Терминал' ||
                        arrival_payments.mileage.type == 'Р/с' ||
                        arrival_payments.mileage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.mileage.type == 'Наличные' ||
                          arrival_payments.mileage.type == 'Терминал' ||
                          arrival_payments.mileage.type == 'Р/с' ||
                          arrival_payments.mileage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.mileage.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.mileage.type == 'Наличные' ||
                        arrival_payments.mileage.type == 'Терминал' ||
                        arrival_payments.mileage.type == 'На карту' ||
                        arrival_payments.mileage.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.mileage.type == 'Наличные' ||
                            arrival_payments.mileage.type == 'Терминал' ||
                            arrival_payments.mileage.type == 'На карту' ||
                            arrival_payments.mileage.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.mileage.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.mileage.type == 'Наличные' ||
                        arrival_payments.mileage.type == 'Терминал' ||
                        arrival_payments.mileage.type == 'На карту' ||
                        arrival_payments.mileage.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.mileage.type == 'Наличные' ||
                            arrival_payments.mileage.type == 'Терминал' ||
                            arrival_payments.mileage.type == 'На карту' ||
                            arrival_payments.mileage.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Топливо -->
              <v-col cols="12" v-if="checkAddPayment('Топливо')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.gas.sum" :label="$t('bookings.gas')"
                      :disabled="isLoading" data-testid="arrival-gas-sum"
                      :messages="messageInBaseCurrency(arrival_payments.gas.sum, arrival_payments.gas.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.gas.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.gas.currency_id = arrival_payments.gas.company_cashbox.currency_id, arrival_payments.gas.company_cashbox_id = arrival_payments.gas.company_cashbox.id"
                      :label="$t('companies.currency')" dense data-testid="arrival-gas-cashbox"></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Топливо')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.gas.type"
                      color="success" value="Наличные" :disabled="arrival_payments.gas.type == 'Терминал' ||
                        arrival_payments.gas.type == 'На карту' ||
                        arrival_payments.gas.type == 'Р/с' ||
                        arrival_payments.gas.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.gas.type == 'Терминал' ||
                          arrival_payments.gas.type == 'На карту' ||
                          arrival_payments.gas.type == 'Р/с' ||
                          arrival_payments.gas.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.gas.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.gas.type == 'Наличные' ||
                        arrival_payments.gas.type == 'На карту' ||
                        arrival_payments.gas.type == 'Р/с' ||
                        arrival_payments.gas.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.gas.type == 'Наличные' ||
                          arrival_payments.gas.type == 'На карту' ||
                          arrival_payments.gas.type == 'Р/с' ||
                          arrival_payments.gas.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.gas.type"
                      color="info" value="На карту" :disabled="arrival_payments.gas.type == 'Наличные' ||
                        arrival_payments.gas.type == 'Терминал' ||
                        arrival_payments.gas.type == 'Р/с' ||
                        arrival_payments.gas.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.gas.type == 'Наличные' ||
                          arrival_payments.gas.type == 'Терминал' ||
                          arrival_payments.gas.type == 'Р/с' ||
                          arrival_payments.gas.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.gas.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.gas.type == 'Наличные' ||
                        arrival_payments.gas.type == 'Терминал' ||
                        arrival_payments.gas.type == 'На карту' ||
                        arrival_payments.gas.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.gas.type == 'Наличные' ||
                            arrival_payments.gas.type == 'Терминал' ||
                            arrival_payments.gas.type == 'На карту' ||
                            arrival_payments.gas.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.gas.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.gas.type == 'Наличные' ||
                        arrival_payments.gas.type == 'Терминал' ||
                        arrival_payments.gas.type == 'На карту' ||
                        arrival_payments.gas.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.gas.type == 'Наличные' ||
                            arrival_payments.gas.type == 'Терминал' ||
                            arrival_payments.gas.type == 'На карту' ||
                            arrival_payments.gas.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Доставка -->
              <v-col cols="12" v-if="checkAddPayment('Доставка')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.delivery.sum" :label="$t('bookings.delivery')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.delivery.sum, arrival_payments.delivery.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.delivery.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.delivery.currency_id = arrival_payments.delivery.company_cashbox.currency_id, arrival_payments.delivery.company_cashbox_id = arrival_payments.delivery.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Доставка')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.delivery.type"
                      color="success" value="Наличные" :disabled="arrival_payments.delivery.type == 'Терминал' ||
                        arrival_payments.delivery.type == 'На карту' ||
                        arrival_payments.delivery.type == 'Р/с' ||
                        arrival_payments.delivery.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery.type == 'Терминал' ||
                          arrival_payments.delivery.type == 'На карту' ||
                          arrival_payments.delivery.type == 'Р/с' ||
                          arrival_payments.delivery.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.delivery.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.delivery.type == 'Наличные' ||
                        arrival_payments.delivery.type == 'На карту' ||
                        arrival_payments.delivery.type == 'Р/с' ||
                        arrival_payments.delivery.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery.type == 'Наличные' ||
                          arrival_payments.delivery.type == 'На карту' ||
                          arrival_payments.delivery.type == 'Р/с' ||
                          arrival_payments.delivery.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.delivery.type"
                      color="info" value="На карту" :disabled="arrival_payments.delivery.type == 'Наличные' ||
                        arrival_payments.delivery.type == 'Терминал' ||
                        arrival_payments.delivery.type == 'Р/с' ||
                        arrival_payments.delivery.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery.type == 'Наличные' ||
                          arrival_payments.delivery.type == 'Терминал' ||
                          arrival_payments.delivery.type == 'Р/с' ||
                          arrival_payments.delivery.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.delivery.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.delivery.type == 'Наличные' ||
                        arrival_payments.delivery.type == 'Терминал' ||
                        arrival_payments.delivery.type == 'На карту' ||
                        arrival_payments.delivery.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.delivery.type == 'Наличные' ||
                            arrival_payments.delivery.type == 'Терминал' ||
                            arrival_payments.delivery.type == 'На карту' ||
                            arrival_payments.delivery.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.delivery.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.delivery.type == 'Наличные' ||
                        arrival_payments.delivery.type == 'Терминал' ||
                        arrival_payments.delivery.type == 'На карту' ||
                        arrival_payments.delivery.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.delivery.type == 'Наличные' ||
                            arrival_payments.delivery.type == 'Терминал' ||
                            arrival_payments.delivery.type == 'На карту' ||
                            arrival_payments.delivery.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Приём -->
              <v-col cols="12" v-if="checkAddPayment('Приём')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.delivery_end.sum" :label="$t('bookings.checkout')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.delivery_end.sum, arrival_payments.delivery_end.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.delivery_end.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.delivery_end.currency_id = arrival_payments.delivery_end.company_cashbox.currency_id, arrival_payments.delivery_end.company_cashbox_id = arrival_payments.delivery_end.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Приём')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.delivery_end.type"
                      color="success" value="Наличные" :disabled="arrival_payments.delivery_end.type == 'Терминал' ||
                        arrival_payments.delivery_end.type == 'На карту' ||
                        arrival_payments.delivery_end.type == 'Р/с' ||
                        arrival_payments.delivery_end.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery_end.type == 'Терминал' ||
                          arrival_payments.delivery_end.type == 'На карту' ||
                          arrival_payments.delivery_end.type == 'Р/с' ||
                          arrival_payments.delivery_end.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.delivery_end.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.delivery_end.type == 'Наличные' ||
                        arrival_payments.delivery_end.type == 'На карту' ||
                        arrival_payments.delivery_end.type == 'Р/с' ||
                        arrival_payments.delivery_end.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery_end.type == 'Наличные' ||
                          arrival_payments.delivery_end.type == 'На карту' ||
                          arrival_payments.delivery_end.type == 'Р/с' ||
                          arrival_payments.delivery_end.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment"
                      v-model="arrival_payments.delivery_end.type" color="info" value="На карту" :disabled="arrival_payments.delivery_end.type == 'Наличные' ||
                        arrival_payments.delivery_end.type == 'Терминал' ||
                        arrival_payments.delivery_end.type == 'Р/с' ||
                        arrival_payments.delivery_end.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.delivery_end.type == 'Наличные' ||
                          arrival_payments.delivery_end.type == 'Терминал' ||
                          arrival_payments.delivery_end.type == 'Р/с' ||
                          arrival_payments.delivery_end.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.delivery_end.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.delivery_end.type == 'Наличные' ||
                        arrival_payments.delivery_end.type == 'Терминал' ||
                        arrival_payments.delivery_end.type == 'На карту' ||
                        arrival_payments.delivery_end.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.delivery_end.type == 'Наличные' ||
                            arrival_payments.delivery_end.type == 'Терминал' ||
                            arrival_payments.delivery_end.type == 'На карту' ||
                            arrival_payments.delivery_end.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.delivery_end.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.delivery_end.type == 'Наличные' ||
                        arrival_payments.delivery_end.type == 'Терминал' ||
                        arrival_payments.delivery_end.type == 'На карту' ||
                        arrival_payments.delivery_end.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.delivery_end.type == 'Наличные' ||
                            arrival_payments.delivery_end.type == 'Терминал' ||
                            arrival_payments.delivery_end.type == 'На карту' ||
                            arrival_payments.delivery_end.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Аренда -->
              <v-col cols="12" v-if="checkAddPayment('Аренда')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.rent.sum" :label="$t('bookings.rent')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.rent.sum, arrival_payments.rent.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.rent.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.rent.currency_id = arrival_payments.rent.company_cashbox.currency_id, arrival_payments.rent.company_cashbox_id = arrival_payments.rent.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Аренда')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.rent.type"
                      color="success" value="Наличные" :disabled="arrival_payments.rent.type == 'Терминал' ||
                        arrival_payments.rent.type == 'На карту' ||
                        arrival_payments.rent.type == 'Р/с' ||
                        arrival_payments.rent.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.rent.type == 'Терминал' ||
                          arrival_payments.rent.type == 'На карту' ||
                          arrival_payments.rent.type == 'Р/с' ||
                          arrival_payments.rent.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.rent.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.rent.type == 'Наличные' ||
                        arrival_payments.rent.type == 'На карту' ||
                        arrival_payments.rent.type == 'Р/с' ||
                        arrival_payments.rent.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.rent.type == 'Наличные' ||
                          arrival_payments.rent.type == 'На карту' ||
                          arrival_payments.rent.type == 'Р/с' ||
                          arrival_payments.rent.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.rent.type"
                      color="info" value="На карту" :disabled="arrival_payments.rent.type == 'Наличные' ||
                        arrival_payments.rent.type == 'Терминал' ||
                        arrival_payments.rent.type == 'Р/с' ||
                        arrival_payments.rent.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.rent.type == 'Наличные' ||
                          arrival_payments.rent.type == 'Терминал' ||
                          arrival_payments.rent.type == 'Р/с' ||
                          arrival_payments.rent.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.rent.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.rent.type == 'Наличные' ||
                        arrival_payments.rent.type == 'Терминал' ||
                        arrival_payments.rent.type == 'На карту' ||
                        arrival_payments.rent.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.rent.type == 'Наличные' ||
                            arrival_payments.rent.type == 'Терминал' ||
                            arrival_payments.rent.type == 'На карту' ||
                            arrival_payments.rent.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.rent.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.rent.type == 'Наличные' ||
                        arrival_payments.rent.type == 'Терминал' ||
                        arrival_payments.rent.type == 'На карту' ||
                        arrival_payments.rent.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.rent.type == 'Наличные' ||
                            arrival_payments.rent.type == 'Терминал' ||
                            arrival_payments.rent.type == 'На карту' ||
                            arrival_payments.rent.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Страховка -->
              <v-col cols="12" v-if="checkAddPayment('Страховка')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.insurance.sum" :label="$t('bookings.insurance')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.insurance.sum, arrival_payments.insurance.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.insurance.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.insurance.currency_id = arrival_payments.insurance.company_cashbox.currency_id, arrival_payments.insurance.company_cashbox_id = arrival_payments.insurance.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Страховка')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.insurance.type"
                      color="success" value="Наличные" :disabled="arrival_payments.insurance.type == 'Терминал' ||
                        arrival_payments.insurance.type == 'На карту' ||
                        arrival_payments.insurance.type == 'Р/с' ||
                        arrival_payments.insurance.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.insurance.type == 'Терминал' ||
                          arrival_payments.insurance.type == 'На карту' ||
                          arrival_payments.insurance.type == 'Р/с' ||
                          arrival_payments.insurance.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.insurance.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.insurance.type == 'Наличные' ||
                        arrival_payments.insurance.type == 'На карту' ||
                        arrival_payments.insurance.type == 'Р/с' ||
                        arrival_payments.insurance.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.insurance.type == 'Наличные' ||
                          arrival_payments.insurance.type == 'На карту' ||
                          arrival_payments.insurance.type == 'Р/с' ||
                          arrival_payments.insurance.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.insurance.type"
                      color="info" value="На карту" :disabled="arrival_payments.insurance.type == 'Наличные' ||
                        arrival_payments.insurance.type == 'Терминал' ||
                        arrival_payments.insurance.type == 'Р/с' ||
                        arrival_payments.insurance.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.insurance.type == 'Наличные' ||
                          arrival_payments.insurance.type == 'Терминал' ||
                          arrival_payments.insurance.type == 'Р/с' ||
                          arrival_payments.insurance.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.insurance.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.insurance.type == 'Наличные' ||
                        arrival_payments.insurance.type == 'Терминал' ||
                        arrival_payments.insurance.type == 'На карту' ||
                        arrival_payments.insurance.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.insurance.type == 'Наличные' ||
                            arrival_payments.insurance.type == 'Терминал' ||
                            arrival_payments.insurance.type == 'На карту' ||
                            arrival_payments.insurance.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.insurance.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.insurance.type == 'Наличные' ||
                        arrival_payments.insurance.type == 'Терминал' ||
                        arrival_payments.insurance.type == 'На карту' ||
                        arrival_payments.insurance.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.insurance.type == 'Наличные' ||
                            arrival_payments.insurance.type == 'Терминал' ||
                            arrival_payments.insurance.type == 'На карту' ||
                            arrival_payments.insurance.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Доп водители -->
              <v-col cols="12" v-if="checkAddPayment('Доп водители')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.add_drivers_cost.sum"
                      :label="$t('bookings.add_drivers_small')" :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.add_drivers_cost.sum, arrival_payments.add_drivers_cost.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.add_drivers_cost.company_cashbox"
                      :items="active_company_cashboxes" :item-text="item => item.name" :return-object="true"
                      :disabled="isLoading"
                      @change="arrival_payments.add_drivers_cost.currency_id = arrival_payments.add_drivers_cost.company_cashbox.currency_id, arrival_payments.add_drivers_cost.company_cashbox_id = arrival_payments.add_drivers_cost.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Доп водители')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.add_drivers_cost.type"
                      color="success" value="Наличные" :disabled="arrival_payments.add_drivers_cost.type == 'Терминал' ||
                        arrival_payments.add_drivers_cost.type == 'На карту' ||
                        arrival_payments.add_drivers_cost.type == 'Р/с' ||
                        arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.add_drivers_cost.type == 'Терминал' ||
                          arrival_payments.add_drivers_cost.type == 'На карту' ||
                          arrival_payments.add_drivers_cost.type == 'Р/с' ||
                          arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment"
                      v-model="arrival_payments.add_drivers_cost.type" color="warning" value="Терминал" :disabled="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                        arrival_payments.add_drivers_cost.type == 'На карту' ||
                        arrival_payments.add_drivers_cost.type == 'Р/с' ||
                        arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                          arrival_payments.add_drivers_cost.type == 'На карту' ||
                          arrival_payments.add_drivers_cost.type == 'Р/с' ||
                          arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment"
                      v-model="arrival_payments.add_drivers_cost.type" color="info" value="На карту" :disabled="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                        arrival_payments.add_drivers_cost.type == 'Терминал' ||
                        arrival_payments.add_drivers_cost.type == 'Р/с' ||
                        arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                          arrival_payments.add_drivers_cost.type == 'Терминал' ||
                          arrival_payments.add_drivers_cost.type == 'Р/с' ||
                          arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment"
                      v-model="arrival_payments.add_drivers_cost.type" color="secondary" class="mt-0 mr-0" dense
                      hide-details value="Р/с" :disabled="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                        arrival_payments.add_drivers_cost.type == 'Терминал' ||
                        arrival_payments.add_drivers_cost.type == 'На карту' ||
                        arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                            arrival_payments.add_drivers_cost.type == 'Терминал' ||
                            arrival_payments.add_drivers_cost.type == 'На карту' ||
                            arrival_payments.add_drivers_cost.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment"
                      v-model="arrival_payments.add_drivers_cost.type" color="error" class="mt-0 mr-0" dense
                      hide-details value="Баланс клиента" :disabled="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                        arrival_payments.add_drivers_cost.type == 'Терминал' ||
                        arrival_payments.add_drivers_cost.type == 'На карту' ||
                        arrival_payments.add_drivers_cost.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.add_drivers_cost.type == 'Наличные' ||
                            arrival_payments.add_drivers_cost.type == 'Терминал' ||
                            arrival_payments.add_drivers_cost.type == 'На карту' ||
                            arrival_payments.add_drivers_cost.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Оборудование -->
              <v-col cols="12" v-if="checkAddPayment('Оборудование')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.equipment.sum" :label="$t('bookings.equipment')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.equipment.sum, arrival_payments.equipment.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.equipment.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.equipment.currency_id = arrival_payments.equipment.company_cashbox.currency_id, arrival_payments.equipment.company_cashbox_id = arrival_payments.equipment.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Оборудование')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.equipment.type"
                      color="success" value="Наличные" :disabled="arrival_payments.equipment.type == 'Терминал' ||
                        arrival_payments.equipment.type == 'На карту' ||
                        arrival_payments.equipment.type == 'Р/с' ||
                        arrival_payments.equipment.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.equipment.type == 'Терминал' ||
                          arrival_payments.equipment.type == 'На карту' ||
                          arrival_payments.equipment.type == 'Р/с' ||
                          arrival_payments.equipment.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.equipment.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.equipment.type == 'Наличные' ||
                        arrival_payments.equipment.type == 'На карту' ||
                        arrival_payments.equipment.type == 'Р/с' ||
                        arrival_payments.equipment.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.equipment.type == 'Наличные' ||
                          arrival_payments.equipment.type == 'На карту' ||
                          arrival_payments.equipment.type == 'Р/с' ||
                          arrival_payments.equipment.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.equipment.type"
                      color="info" value="На карту" :disabled="arrival_payments.equipment.type == 'Наличные' ||
                        arrival_payments.equipment.type == 'Терминал' ||
                        arrival_payments.equipment.type == 'Р/с' ||
                        arrival_payments.equipment.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.equipment.type == 'Наличные' ||
                          arrival_payments.equipment.type == 'Терминал' ||
                          arrival_payments.equipment.type == 'Р/с' ||
                          arrival_payments.equipment.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.equipment.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.equipment.type == 'Наличные' ||
                        arrival_payments.equipment.type == 'Терминал' ||
                        arrival_payments.equipment.type == 'На карту' ||
                        arrival_payments.equipment.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.equipment.type == 'Наличные' ||
                            arrival_payments.equipment.type == 'Терминал' ||
                            arrival_payments.equipment.type == 'На карту' ||
                            arrival_payments.equipment.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.equipment.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.equipment.type == 'Наличные' ||
                        arrival_payments.equipment.type == 'Терминал' ||
                        arrival_payments.equipment.type == 'На карту' ||
                        arrival_payments.equipment.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.equipment.type == 'Наличные' ||
                            arrival_payments.equipment.type == 'Терминал' ||
                            arrival_payments.equipment.type == 'На карту' ||
                            arrival_payments.equipment.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Штрафы -->
              <v-col cols="12" v-if="checkAddPayment('Штрафы')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.fine.sum" :label="$t('bookings.fines')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.fine.sum, arrival_payments.fine.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.fine.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.fine.currency_id = arrival_payments.fine.company_cashbox.currency_id, arrival_payments.fine.company_cashbox_id = arrival_payments.fine.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Штрафы')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.fine.type"
                      color="success" value="Наличные" :disabled="arrival_payments.fine.type == 'Терминал' ||
                        arrival_payments.fine.type == 'На карту' ||
                        arrival_payments.fine.type == 'Р/с' ||
                        arrival_payments.fine.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.fine.type == 'Терминал' ||
                          arrival_payments.fine.type == 'На карту' ||
                          arrival_payments.fine.type == 'Р/с' ||
                          arrival_payments.fine.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.fine.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.fine.type == 'Наличные' ||
                        arrival_payments.fine.type == 'На карту' ||
                        arrival_payments.fine.type == 'Р/с' ||
                        arrival_payments.fine.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.fine.type == 'Наличные' ||
                          arrival_payments.fine.type == 'На карту' ||
                          arrival_payments.fine.type == 'Р/с' ||
                          arrival_payments.fine.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.fine.type"
                      color="info" value="На карту" :disabled="arrival_payments.fine.type == 'Наличные' ||
                        arrival_payments.fine.type == 'Терминал' ||
                        arrival_payments.fine.type == 'Р/с' ||
                        arrival_payments.fine.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.fine.type == 'Наличные' ||
                          arrival_payments.fine.type == 'Терминал' ||
                          arrival_payments.fine.type == 'Р/с' ||
                          arrival_payments.fine.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.fine.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.fine.type == 'Наличные' ||
                        arrival_payments.fine.type == 'Терминал' ||
                        arrival_payments.fine.type == 'На карту' ||
                        arrival_payments.fine.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.fine.type == 'Наличные' ||
                            arrival_payments.fine.type == 'Терминал' ||
                            arrival_payments.fine.type == 'На карту' ||
                            arrival_payments.fine.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.fine.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.fine.type == 'Наличные' ||
                        arrival_payments.fine.type == 'Терминал' ||
                        arrival_payments.fine.type == 'На карту' ||
                        arrival_payments.fine.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.fine.type == 'Наличные' ||
                            arrival_payments.fine.type == 'Терминал' ||
                            arrival_payments.fine.type == 'На карту' ||
                            arrival_payments.fine.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Повреждения -->
              <v-col cols="12" v-if="checkAddPayment('Повреждения')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.damage.sum" :label="$t('bookings.damages')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.damage.sum, arrival_payments.damage.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.damage.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.damage.currency_id = arrival_payments.damage.company_cashbox.currency_id, arrival_payments.damage.company_cashbox_id = arrival_payments.damage.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Повреждения')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.damage.type"
                      color="success" value="Наличные" :disabled="arrival_payments.damage.type == 'Терминал' ||
                        arrival_payments.damage.type == 'На карту' ||
                        arrival_payments.damage.type == 'Р/с' ||
                        arrival_payments.damage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.damage.type == 'Терминал' ||
                          arrival_payments.damage.type == 'На карту' ||
                          arrival_payments.damage.type == 'Р/с' ||
                          arrival_payments.damage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.damage.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.damage.type == 'Наличные' ||
                        arrival_payments.damage.type == 'На карту' ||
                        arrival_payments.damage.type == 'Р/с' ||
                        arrival_payments.damage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.damage.type == 'Наличные' ||
                          arrival_payments.damage.type == 'На карту' ||
                          arrival_payments.damage.type == 'Р/с' ||
                          arrival_payments.damage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.damage.type"
                      color="info" value="На карту" :disabled="arrival_payments.damage.type == 'Наличные' ||
                        arrival_payments.damage.type == 'Терминал' ||
                        arrival_payments.damage.type == 'Р/с' ||
                        arrival_payments.damage.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.damage.type == 'Наличные' ||
                          arrival_payments.damage.type == 'Терминал' ||
                          arrival_payments.damage.type == 'Р/с' ||
                          arrival_payments.damage.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.damage.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.damage.type == 'Наличные' ||
                        arrival_payments.damage.type == 'Терминал' ||
                        arrival_payments.damage.type == 'На карту' ||
                        arrival_payments.damage.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.damage.type == 'Наличные' ||
                            arrival_payments.damage.type == 'Терминал' ||
                            arrival_payments.damage.type == 'На карту' ||
                            arrival_payments.damage.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.damage.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.damage.type == 'Наличные' ||
                        arrival_payments.damage.type == 'Терминал' ||
                        arrival_payments.damage.type == 'На карту' ||
                        arrival_payments.damage.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.damage.type == 'Наличные' ||
                            arrival_payments.damage.type == 'Терминал' ||
                            arrival_payments.damage.type == 'На карту' ||
                            arrival_payments.damage.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Другое -->
              <v-col cols="12" v-if="checkAddPayment('Другое')">
                <v-row align="center">
                  <v-col auto>
                    <v-text-field v-model.number="arrival_payments.other.sum" :label="$t('bookings.other')"
                      :disabled="isLoading"
                      :messages="messageInBaseCurrency(arrival_payments.other.sum, arrival_payments.other.currency_id)"
                      dense></v-text-field>
                  </v-col>
                  <v-col auto v-if="company && company.multicurrency_cashboxes">
                    <v-select v-model="arrival_payments.other.company_cashbox" :items="active_company_cashboxes"
                      :item-text="item => item.name" :return-object="true" :disabled="isLoading"
                      @change="arrival_payments.other.currency_id = arrival_payments.other.company_cashbox.currency_id, arrival_payments.other.company_cashbox_id = arrival_payments.other.company_cashbox.id"
                      :label="$t('companies.currency')" dense></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="checkAddPayment('Другое')">
                <v-row align="center">
                  <v-col cols="12" class="d-flex align-center justify-space-between">
                    <v-checkbox v-if="company && company.cash_payment" v-model="arrival_payments.other.type"
                      color="success" value="Наличные" :disabled="arrival_payments.other.type == 'Терминал' ||
                        arrival_payments.other.type == 'На карту' ||
                        arrival_payments.other.type == 'Р/с' ||
                        arrival_payments.other.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.other.type == 'Терминал' ||
                          arrival_payments.other.type == 'На карту' ||
                          arrival_payments.other.type == 'Р/с' ||
                          arrival_payments.other.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="success" v-tooltip="{
                          content: $t('tooltips.cash_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-cash
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.cashless_payment" v-model="arrival_payments.other.type"
                      color="warning" value="Терминал" :disabled="arrival_payments.other.type == 'Наличные' ||
                        arrival_payments.other.type == 'На карту' ||
                        arrival_payments.other.type == 'Р/с' ||
                        arrival_payments.other.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.other.type == 'Наличные' ||
                          arrival_payments.other.type == 'На карту' ||
                          arrival_payments.other.type == 'Р/с' ||
                          arrival_payments.other.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="warning" v-tooltip="{
                          content: $t('tooltips.terminal_count'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-contactless-payment-circle-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.card_to_card_payment" v-model="arrival_payments.other.type"
                      color="info" value="На карту" :disabled="arrival_payments.other.type == 'Наличные' ||
                        arrival_payments.other.type == 'Терминал' ||
                        arrival_payments.other.type == 'Р/с' ||
                        arrival_payments.other.type == 'Баланс клиента' ||
                        isLoading
                        " class="mt-0 mr-0" dense hide-details :style="arrival_payments.other.type == 'Наличные' ||
                          arrival_payments.other.type == 'Терминал' ||
                          arrival_payments.other.type == 'Р/с' ||
                          arrival_payments.other.type == 'Баланс клиента' ||
                          isLoading
                          ? 'opacity: 0.4;'
                          : ''
                          ">
                      <template v-slot:label>
                        <v-icon class="text-center mr-2" color="info" v-tooltip="{
                          content: $t('money.card_to_card'),
                          placement: 'bottom-center',
                          classes: ['info'],
                          targetClasses: ['it-has-a-tooltip'],
                          delay: {
                            show: 500,
                            hide: 500,
                          },
                        }">
                          mdi-credit-card-check-outline
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.entity_payment" v-model="arrival_payments.other.type"
                      color="secondary" class="mt-0 mr-0" dense hide-details value="Р/с" :disabled="arrival_payments.other.type == 'Наличные' ||
                        arrival_payments.other.type == 'Терминал' ||
                        arrival_payments.other.type == 'На карту' ||
                        arrival_payments.other.type == 'Баланс клиента' ||
                        isLoading
                        " :style="arrival_payments.other.type == 'Наличные' ||
                            arrival_payments.other.type == 'Терминал' ||
                            arrival_payments.other.type == 'На карту' ||
                            arrival_payments.other.type == 'Баланс клиента' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('tooltips.entity_count'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="secondary">
                          mdi-bank
                        </v-icon>
                      </template>
                    </v-checkbox>
                    <v-checkbox v-if="company && company.client_payment" v-model="arrival_payments.other.type"
                      color="error" class="mt-0 mr-0" dense hide-details value="Баланс клиента" :disabled="arrival_payments.other.type == 'Наличные' ||
                        arrival_payments.other.type == 'Терминал' ||
                        arrival_payments.other.type == 'На карту' ||
                        arrival_payments.other.type == 'Р/с' ||
                        isLoading
                        " :style="arrival_payments.other.type == 'Наличные' ||
                            arrival_payments.other.type == 'Терминал' ||
                            arrival_payments.other.type == 'На карту' ||
                            arrival_payments.other.type == 'Р/с' ||
                            isLoading
                            ? 'opacity: 0.4;'
                            : ''
                            " v-tooltip="{
                              content: $t('money.client_balance'),
                              placement: 'bottom-center',
                              classes: ['info'],
                              targetClasses: ['it-has-a-tooltip'],
                              delay: {
                                show: 500,
                                hide: 500,
                              },
                            }">
                      <template v-slot:label>
                        <v-icon class="text-center" color="error">
                          mdi-account-arrow-right
                        </v-icon>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" :class="isMobile ? '' : 'd-flex align-center justify-space-between'">
            <v-switch v-model="showProblems" :label="$t('bookings.problems')" :disabled="isLoading"
              hide-details></v-switch>
            <v-switch v-if="!hasDepositHold" v-model="partReturnDeposit" :disabled="giveNullDeposit || isLoading"
              :label="$t('bookings.part_deposit')" hide-details></v-switch>
            <v-switch v-model="dont_send_review_reminder" :disabled="isLoading" :label="$t('bookings.dont_send_review')"
              hide-details></v-switch>
          </v-col>
          <v-col cols="12" v-if="showProblems" class="d-flex">
            <v-col cols="12" md="6" sm="12">
              <v-textarea v-model="client.problems_description" clearable auto-grow rows="1" :disabled="isLoading"
                :label="$t('bookings.problems_description')"></v-textarea>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
                :disabled="isLoading" :label="$t('bookings.client_category')"></v-select>
            </v-col>
          </v-col>
          <v-col cols="12" v-if="partReturnDeposit && !hasDepositHold">
            <v-text-field v-model.number="arrival_payments.deposit.sum" :label="$t('bookings.return_deposit_desc')"
              :disabled="isLoading"></v-text-field>
          </v-col>
          <!-- <v-col cols="12" v-if="set_car && set_car.traccar_id">
            <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <h3 class="text-center">{{ $t('companies.beacons_report') }}</h3>
              </v-col>
              <v-col cols="12" v-if="isTrackerReportLoading">
                <v-skeleton-loader class="mx-auto" max-width="300" type="list-item"></v-skeleton-loader>
                <v-skeleton-loader class="mx-auto" max-width="300" type="list-item"></v-skeleton-loader>
                <v-skeleton-loader class="mx-auto" max-width="300" type="list-item"></v-skeleton-loader>
              </v-col>
              <v-col cols="12" v-else>
                <v-text-field v-model="tracker_report.distance"
                  :label="$t('trackers.distance') + ' ' + $t('cars.kilometers')" readonly></v-text-field>
                <v-text-field v-model="tracker_report.speed"
                  :label="$t('trackers.average_speed') + ' ' + $t('cars.kilometers_hour')" readonly></v-text-field>
                <v-text-field v-model="tracker_report.max_speed"
                  :label="$t('trackers.maxSpeed') + ' ' + $t('cars.kilometers_hour')" readonly></v-text-field>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-5">
        <v-spacer></v-spacer>
        <v-btn text class="mr-2" @click="closeArrivalDialog()">
          {{ $t("custom.close") }}
        </v-btn>
        <v-btn color="success" @click="inHome()" :loading="isLoading" :disabled="isLoading || damageControlBlocked" data-testid="arrival-save">
          {{ $t("bookings.checkout_car") }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/en-gb";
import CarDamageMarker from './CarDamageMarker.vue'
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import DamageControlEntry from "@/components/dashboard/damage_control/entry/DamageControlEntry.vue";
import DamageControlStrictAlert from "@/components/dashboard/damage_control/entry/DamageControlStrictAlert.vue";
import damageControlDialogMixin from "@/components/dashboard/damage_control/entry/dialogMixin";
import { keyVisible, ADD_SERVICE_FEATURES, PAYMENT_SLOT_FEATURES } from "@/utils/rentalObjectFeatures";
import { translateFineState as translateFineStateText } from "@/utils/localeInfra";

export default {
  mixins: [rentalObjectMixin, damageControlDialogMixin],
  name: 'ArrivalDialog',
  components: {
    CarDamageMarker,
    DamageControlEntry,
    DamageControlStrictAlert
  },
  props: {
    value: Boolean,
    booking: {
      type: Object,
      required: true
    },
    set_car: {
      type: Object,
      default: null
    },
    fines: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: null
    },
    company_cashboxes: {
      type: Array,
      default: () => []
    },
    worker_accounts: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isTrackerReportLoading: {
      type: Boolean,
      default: false
    },
    tracker_report: {
      type: Object,
      default: () => ({
        distance: 0,
        speed: 0,
        max_speed: 0
      })
    },
    showSelectWorkerCashbox: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isProcessingLocal: false, // Локальная защита от двойного клика
      giveNullDeposit: false,
      giveFullDeposit: true,
      showProblems: false,
      partReturnDeposit: false,
      depositHoldDeductions: [],
      depositHoldDeferred: 0,
      depositHoldRetainUntil: null,
      dont_send_review_reminder: false,
      showCleanPaid: false,
      company_cashbox_id: null,
      worker_account_id: null,
      selected_add_services: [],
      search_fines: '',
      client: {
        problems_description: '',
        category: null
      },
      calendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY H:mm", // Uses 'iso' if missing,
        // timeAdjust: "now",
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          dates: new Date(),
        },
      ],
      arrival_payments: {
        deposit: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        clean: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        additional_hours: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        mileage: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        gas: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        delivery: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        delivery_end: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        rent: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        insurance: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        add_drivers_cost: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        equipment: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        // FT-102: countsConfig в BookingCard.buildAllCounts читает p.addons — без ключа приёмка падала бы на undefined.sum
        addons: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        fine: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        damage: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null },
        other: { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null }
      },
      add_services: [
        { text: this.$t('custom.clean'), value: 'Мойка' },
        { text: this.$t('bookings.extra_time'), value: 'Дополнительное время' },
        { text: this.$t('bookings.extra_mileage_big'), value: 'Превышение пробега' },
        { text: this.$t('bookings.gas'), value: 'Топливо' },
        { text: this.$t('bookings.delivery'), value: 'Доставка' },
        { text: this.$t('bookings.checkout'), value: 'Приём' },
        { text: this.$t('bookings.rent'), value: 'Аренда' },
        { text: this.$t('bookings.insurance'), value: 'Страховка' },
        { text: this.$t('bookings.add_drivers_small'), value: 'Доп водители' },
        { text: this.$t('bookings.equipment'), value: 'Оборудование' },
        { text: this.$t('bookings.fines'), value: 'Штрафы' },
        { text: this.$t('bookings.damages'), value: 'Повреждения' },
        { text: this.$t('bookings.other'), value: 'Другое' }
      ],
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      fines_headers_small: [
        { text: this.$t('fines.number'), value: 'number', align: 'center' },
        { text: this.$t('custom.date'), value: 'date', align: 'center' },
        { text: this.$t('custom.client'), value: 'client_id', align: 'center' },
        { text: this.$t('custom.sum'), value: 'sum', align: 'center' },
        { text: this.$t('custom.description'), value: 'description', align: 'center' },
        { text: this.$t('fines.state'), value: 'state', align: 'center' }
      ],
      fines_state: [
        { text: this.$t("fines_state.created"), value: "Создан" },
        { text: this.$t("fines_state.notify"), value: "Оповещён" },
        { text: this.$t("fines_state.paid"), value: "Оплачен" },
        { text: this.$t("fines_state.refund"), value: "Возмещён" },
      ],
      limitExept: false,
      limitCost: 0
    }
  },
  mounted() {
    this.presetCashboxes();
  },
  computed: {
    // Варианты «добавить доплату» без скрытых фич: у вело-компании нет штрафов,
    // перепробега, топлива и страховки при возврате.
    visibleAddServices() {
      return this.add_services.filter((s) => keyVisible(this.rental_object, ADD_SERVICE_FEATURES, s.value));
    },
    showArrivalDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    hasDepositHold() {
      const hold = this.booking && this.booking.deposit_hold;
      return !!(hold && ["pending", "held"].includes(hold.state));
    },
    hasUnsecuredDepositHold() {
      const hold = this.booking && this.booking.deposit_hold;
      return !!(hold && hold.state === "unsecured");
    },
    depositHoldReturn() {
      const hold = this.booking && this.booking.deposit_hold;
      const total = Number(hold && hold.deposit_amount) || 0;
      const deducted = this.depositHoldDeductions.reduce((sum, row) => sum + (Number(row.sum) || 0), 0);
      return Number((total - deducted - (Number(this.depositHoldDeferred) || 0)).toFixed(2));
    },
    depositHoldValidationError() {
      if (this.depositHoldReturn < 0) return "bookings.deposit_hold.errors.split";
      if (Number(this.depositHoldDeferred) > 0 && !this.depositHoldRetainUntil) {
        return "bookings.deposit_hold.errors.retain_until_required";
      }
      const invalidRow = this.depositHoldDeductions.some((row) =>
        !row.category || !String(row.reason || "").trim() || !(Number(row.sum) > 0));
      return invalidRow ? "bookings.deposit_hold.errors.deduction" : "";
    },
    depositHoldCategories() {
      return ["clean", "gas", "damage", "mileage", "other"].map((value) => ({
        value,
        text: this.$t(`bookings.deposit_hold.categories.${value}`),
      }));
    },
    active_company_cashboxes() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.company_cashboxes) {
        let cashboxes = [];
        this.$store.getters.getCompany.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    currencies() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currencies
      ) {
        return this.$store.getters.getCompany.company.currencies;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
    exchange_rates() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.exchange_rates) {
        return this.$store.getters.getCompany.company.exchange_rates;
      } else {
        return [];
      }
    },
  },
  methods: {
    addDepositHoldDeduction() {
      this.depositHoldDeductions.push({ category: "other", reason: "", sum: null });
    },
    removeDepositHoldDeduction(index) {
      this.depositHoldDeductions.splice(index, 1);
    },
    resetDepositHoldPlan() {
      this.depositHoldDeductions = [];
      this.depositHoldDeferred = 0;
      const days = Number(this.company && this.company.part_return_deposit_days) || 0;
      this.depositHoldRetainUntil = days > 0 ? moment().add(days, "days").format("YYYY-MM-DD") : null;
    },
    // FT-183: слоты доплат скрытых фич возвращаются к начальному значению при каждом
    // открытии. Диалог монтируется один раз, а BookingCard переиспользуется между
    // бронированиями: сумма или тип, введённые раньше и не сохранённые, иначе ушли бы
    // в возврат невидимой строкой (операции строятся по сумме, проверка касс — по типу).
    resetHiddenPaymentSlots() {
      Object.keys(PAYMENT_SLOT_FEATURES).forEach((key) => {
        if (keyVisible(this.rental_object, PAYMENT_SLOT_FEATURES, key)) return;
        this.arrival_payments[key] = { type: null, sum: 0, currency_id: null, company_cashbox_id: null, company_cashbox: null };
      });
    },
    // Предзаполнение кассы во ВСЕХ услугах приёмки.
    //
    // Раньше это лежало прямо в mounted() и было развёрнуто по 14 услугам вручную, а
    // источник кассы брался так:
    //
    //     let default_cashbox = active_company_cashboxes[0] ... : null
    //     this.arrival_payments.rent.currency_id = default_cashbox.currency_id  // ← тут
    //
    // Следующей же строкой шло обращение к полю, то есть при пустом списке касс весь
    // mounted падал TypeError и НИ ОДНА услуга кассы не получала. Пустой список — не
    // экзотика: active_company_cashboxes это computed по стору, а диалог монтируется
    // вместе с карточкой брони, то есть до того, как компания подъедет (открыли бронь
    // прямой ссылкой). Дальше такая приёмка уходила на сервер без касс, и каждая услуга
    // там наследовала кассу соседней — см. api#561.
    //
    // Поэтому: молча ничего не делаем, если касс нет, и повторяем попытку при открытии
    // диалога, когда стор уже точно загружен.
    presetCashboxes({ force = false } = {}) {
      const cashboxes = this.active_company_cashboxes;
      if (!cashboxes || !cashboxes.length) return;

      const defaultCashbox = cashboxes.find((cashbox) => cashbox.is_default) || cashboxes[0];
      if (!defaultCashbox || !defaultCashbox.currency_id) return;

      const availableIds = new Set(cashboxes.map((cashbox) => cashbox.id));

      Object.keys(this.arrival_payments).forEach((key) => {
        const slot = this.arrival_payments[key];
        if (!slot) return;
        // Держим выбор пользователя только внутри одного открытия диалога и только пока
        // касса жива в текущем филиале. Всё остальное перетираем: карточка брони живёт
        // дольше диалога (см. вызов с force при открытии).
        if (!force && slot.company_cashbox_id && availableIds.has(slot.company_cashbox_id)) return;

        slot.company_cashbox = defaultCashbox;
        slot.currency_id = defaultCashbox.currency_id;
        slot.company_cashbox_id = defaultCashbox.id;
      });
    },

    closeArrivalDialog() {
      this.isProcessingLocal = false;
      this.$emit('close')
    },
    async inHome() {
      if (this.damageControlBlocked) return;
      console.log("inHome called, isLoading:", this.isLoading, "isProcessingLocal:", this.isProcessingLocal);
      
      // Защита от двойного вызова - проверяем флаг загрузки из родителя
      // isLoading = true означает что родитель обрабатывает запрос
      if (this.isLoading) {
        console.warn("inHome: parent is loading, skipping");
        return;
      }
      
      if (this.isProcessingLocal) {
        console.warn("inHome: local processing is already running, skipping");
        return;
      }
      
      // Устанавливаем локальную блокировку
      this.isProcessingLocal = true;
      console.log("inHome: isProcessingLocal set to true");
      
      // ВСЕ ВАЛИДАЦИИ ПЕРЕНЕСЕНЫ В BookingCard.inHomeRefactored()
      // Здесь только подготовка данных и emit
      
      try {
        if (this.hasDepositHold && this.depositHoldValidationError) {
          this.$notify(this.$t("errors.return_car"), this.$t(this.depositHoldValidationError), "warning", 5000);
          this.isProcessingLocal = false;
          return;
        }
        // Проставляем в базе в поле arrival_payments.deposit сумму
        let currentDepositSum = this.currentDeposit();
        if (this.arrival_payments.deposit.currency_id != this.base_currency_id) {
          currentDepositSum = this.sumInNonBaseCurrency(this.currentDeposit(), this.arrival_payments.deposit.currency_id);
        }
        if (this.hasDepositHold) {
          this.arrival_payments.deposit.sum = 0;
        } else if (this.partReturnDeposit) {
          this.arrival_payments.deposit.sum = parseFloat(parseFloat(this.arrival_payments.deposit.sum).toFixed(2));
        } else {
          this.arrival_payments.deposit.sum = parseFloat(parseFloat(currentDepositSum).toFixed(2));
        }
        // Создаём callback для загрузки фото повреждений
        // Будет вызван в BookingCard после всех диалогов, перед отправкой на сервер
        const uploadDamageImageCallback = async () => {
          if (this.company && this.company.damage_marking && this.$refs.carDamageMarker) {
            console.log('Starting uploadDamageImageToS3 (checkout), damages count:', this.booking.checkout_damages ? this.booking.checkout_damages.length : 0);
            try {
              const uploadPromise = this.$refs.carDamageMarker.uploadDamageImageToS3();
              const timeoutPromise = new Promise((resolve) => {
                setTimeout(() => {
                  console.info('Upload timeout reached (30s)');
                  resolve({ success: false, error: 'Upload timeout' });
                }, 30000);
              });
              
              const uploadResult = await Promise.race([uploadPromise, timeoutPromise]);
              console.log('Upload completed (checkout), result:', uploadResult);
              
              if (uploadResult && uploadResult.success) {
                console.log('Checkout damage image uploaded successfully:', uploadResult.image_url);
                return uploadResult.image_url;
              } else if (uploadResult && !uploadResult.success) {
                console.error('Failed to upload checkout damage image:', uploadResult.error);
              }
            } catch (error) {
              console.error('Error uploading checkout damage image:', error);
            }
          } else {
            console.log('Skipping checkout image upload - damage_marking disabled or ref not found');
          }
          return null;
        };
        
        const data = {
          booking: this.booking,
          arrival_payments: this.arrival_payments,
          client: this.client,
          giveNullDeposit: this.giveNullDeposit,
          partReturnDeposit: this.partReturnDeposit,
          depositHold: this.hasDepositHold ? {
            deductions: this.depositHoldDeductions.map((row) => ({
              category: row.category,
              reason: String(row.reason || "").trim(),
              sum: Number(row.sum),
            })),
            deferred: Number(this.depositHoldDeferred) || 0,
            retain_until: Number(this.depositHoldDeferred) > 0 ? this.depositHoldRetainUntil : null,
          } : null,
          dont_send_review_reminder: this.dont_send_review_reminder,
          // company_cashbox_id: this.company_cashbox_id,
          worker_account_id: this.worker_account_id,
          showProblems: this.showProblems,
          showCleanPaid: this.showCleanPaid,
          uploadDamageImageCallback: uploadDamageImageCallback
        }
        // Проверка даты перенесена в BookingCard.inHomeRefactored
        this.$emit('in-home', data)
      } catch (error) {
        console.error('Error in inHome:', error);
        this.isProcessingLocal = false;
        throw error;
      }
    },
    sumInBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) / parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    sumInNonBaseCurrency(sum, currency_id) {
      if (this.exchange_rates.length > 0 && currency_id) {
        let exchange_rate = this.exchange_rates.find((exchange_rate) => exchange_rate.target_currency_id == currency_id);
        if (exchange_rate) {
          return (parseFloat(sum) * parseFloat(exchange_rate.rate)).toFixed(2);
        } else {
          return sum / 1;
        }
      } else {
        return sum / 1;
      }
    },
    messageInBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(this.base_currency_id)}`;
      } else {
        return '';
      }
    },
    messageInNonBaseCurrency(sum, currency_id) {
      if (sum && currency_id && this.base_currency_id && this.base_currency_id != currency_id) {
        return `${this.sumInNonBaseCurrency(sum, currency_id)} ${this.findCurrencySymbol(currency_id)}`;
      } else {
        return '';
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    checkAddPayment(service) {
      return this.selected_add_services.includes(service)
    },
    checkMileageLimit() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.booking.end_mileage > this.booking.start_mileage
      ) {
        let mileage = Math.floor(
          (this.booking.end_mileage - this.booking.start_mileage) /
          this.booking.days
        );
        let limit = this.$store.getters.getCompany.company.mileage_limit;

        if (
          this.set_car.extra_mileage_km > 0 &&
          this.set_car.extra_mileage_price > 0
        ) {
          limit = this.set_car.extra_mileage_km;
        }
        if (mileage > limit && limit > 0) {
          this.limitExept = true;
          this.giveFullDeposit = false;
          if (
            this.selected_add_services.findIndex((item) => item == "Превышение пробега") < 0
          ) {
            this.selected_add_services.push("Превышение пробега");
          }
          return true;
        } else {
          this.limitExept = false;
          return false;
        }
      }
    },
    returnDate(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatCreatedAtWithYear(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    translateFinesState(state) {
      return translateFineStateText(this.$t.bind(this), state);
    },
    stateFineColor(state) {
      switch (state) {
        case 'fresh':
          return 'orange--text'
        case 'paid':
          return 'green--text'
        case 'canceled':
          return 'red--text'
        default:
          return ''
      }
    },
    updateFinesState(id, state) {
      this.$emit('update-fine-state', { id, state })
    },
    calcExtraMileagePrice() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company
      ) {
        let price = this.$store.getters.getCompany.company.mileage_limit_cost;

        if (
          this.set_car.extra_mileage_km > 0 &&
          this.set_car.extra_mileage_price > 0
        ) {
          price = this.set_car.extra_mileage_price;
        }

        this.limitCost = this.returnMileageExt() > 0 ? parseFloat((this.returnMileageExt() * price).toFixed(2)) : 0;
      } else {
        this.limitCost = 0;
      }
    },
    safeParseFloat(value) {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    },
    returnDeposit() {
      let deposit, memoryDeposit;
      if (!this.giveNullDeposit) {
        // Если возвращаем залог
        // Конвертируем текущий депозит в выбранную валюту депозита
        let currentDepositInBase = this.sumInBaseCurrency(this.currentDeposit(), this.base_currency_id);
        deposit = this.sumInNonBaseCurrency(currentDepositInBase, this.arrival_payments.deposit.currency_id);
        memoryDeposit = this.sumInNonBaseCurrency(currentDepositInBase, this.arrival_payments.deposit.currency_id);

        // Функция для конвертации суммы с учетом валюты
        const convertAmount = (amount, fromCurrencyId) => {
          if (!amount || !fromCurrencyId) return 0;

          // Если валюты совпадают с валютой депозита
          if (fromCurrencyId === this.arrival_payments.deposit.currency_id) {
            return this.safeParseFloat(amount);
          }

          // Сначала конвертируем в базовую валюту
          let amountInBase = this.sumInBaseCurrency(amount, fromCurrencyId);
          // Затем из базовой в валюту депозита
          return this.safeParseFloat(this.sumInNonBaseCurrency(amountInBase, this.arrival_payments.deposit.currency_id));
        };

        // Проверяем каждый платеж и конвертируем если типы оплаты совпадают
        const payments = [
          'rent', 'clean', 'delivery', 'delivery_end', 'additional_hours',
          'mileage', 'insurance', 'add_drivers_cost', 'gas', 'equipment',
          'fine', 'damage', 'other'
        ];

        payments.forEach(paymentType => {
          if (
            this.arrival_payments[paymentType].type === this.arrival_payments.deposit.type &&
            this.arrival_payments[paymentType].type != null &&
            this.arrival_payments.deposit.type != null
          ) {
            deposit -= convertAmount(
              this.arrival_payments[paymentType].sum,
              this.arrival_payments[paymentType].currency_id
            );
          }
        });

        // Частичный возврат
        if (this.partReturnDeposit) {
          let add_payments = memoryDeposit - deposit;
          deposit = this.safeParseFloat(this.arrival_payments.deposit.sum) - add_payments;
        }
      } else {
        // Если не возвращаем залог, считаем общую сумму всех платежей в валюте депозита
        deposit = 0;
        const payments = [
          'rent', 'clean', 'delivery', 'delivery_end', 'additional_hours',
          'mileage', 'insurance', 'add_drivers_cost', 'gas', 'equipment',
          'fine', 'damage', 'other'
        ];

        payments.forEach(paymentType => {
          deposit -= this.sumInBaseCurrency(
            this.arrival_payments[paymentType].sum,
            this.arrival_payments[paymentType].currency_id
          );
        });

        // Конвертируем итоговую сумму в валюту депозита
        deposit = this.sumInNonBaseCurrency(
          deposit,
          this.arrival_payments.deposit.currency_id
        );
      }

      return parseFloat(parseFloat(deposit).toFixed(2));
    },
    returnMileageExt() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company
      ) {
        let limit = this.$store.getters.getCompany.company.mileage_limit;

        if (
          this.set_car.extra_mileage_km > 0 &&
          this.set_car.extra_mileage_price > 0
        ) {
          limit = this.set_car.extra_mileage_km;
        }

        return parseFloat((
          ((this.booking.end_mileage - this.booking.start_mileage) /
            this.booking.days -
            limit) *
          this.booking.days
        ).toFixed(2));
      }
    },
    calcClean() {
      if (this.booking && this.booking.clean_payment == 0) {
        this.arrival_payments.clean.sum = 0;
        if (
          this.selected_add_services.findIndex((item) => item == "Мойка") < 0
        ) {
          this.selected_add_services.push("Мойка");
        }
        this.giveFullDeposit = false;
      } else if (this.booking && this.booking.clean_payment > 0) {
        this.showCleanPaid = true;
      }
    },
    calcGas() {
      this.giveFullDeposit = false;
      if (
        this.selected_add_services.findIndex((item) => item == "Топливо") < 0
      ) {
        this.selected_add_services.push("Топливо");
      }
    },
    currentDeposit() {
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      } else if (this.booking.hourly) {
        let check_number = Number(this.booking.hourly_deposit) === this.booking.hourly_deposit;
        return check_number ? parseFloat(this.booking.hourly_deposit.toFixed(2)) : 0;
      } else if (this.booking.weekly) {
        let check_number = Number(this.booking.weekly_deposit) === this.booking.weekly_deposit;
        return check_number ? parseFloat(this.booking.weekly_deposit.toFixed(2)) : 0;
      } else if (this.booking.monthly) {
        let check_number = Number(this.booking.monthly_deposit) === this.booking.monthly_deposit;
        return check_number ? parseFloat(this.booking.monthly_deposit.toFixed(2)) : 0;
      } else {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      }
    },
  },
  watch: {
    // Кассы приходят из стора computed'ом, а диалог монтируется вместе с карточкой брони,
    // то есть может успеть раньше ответа company-запроса. Тогда ни mounted, ни открытие
    // диалога касс не увидят — добираем, как только список наполнился. Без force, чтобы
    // не затирать выбор, если пользователь уже что-то поставил.
    active_company_cashboxes(newVal) {
      if (newVal && newVal.length) this.presetCashboxes();
    },
    value(newVal) {
      if (newVal) {
        // На КАЖДОЕ открытие сбрасываем кассы к дефолтной: BookingCard переиспользуется
        // между бронированиями (router-view ключуется ручным счётчиком, диалог висит без
        // v-if), поэтому касса, выбранная в брони A, иначе уезжает в бронь B — а
        // смешанные валюты в приёмке это норма, так что подмена не бросается в глаза.
        // FT-183: сначала сброс слотов скрытых доплат, затем касса по умолчанию.
        this.resetHiddenPaymentSlots();
        this.presetCashboxes({ force: true });
        this.selected_add_services = []
        this.giveNullDeposit = false
        this.giveFullDeposit = true
        this.showProblems = false
        this.partReturnDeposit = false
        if (typeof this.resetDepositHoldPlan === "function") this.resetDepositHoldPlan()
        this.dont_send_review_reminder = false
        // Инициализируем поле для повреждений, если его нет
        if (!this.booking.checkout_damages) {
          this.$set(this.booking, 'checkout_damages', []);
        }
      }
    },
    // Сбрасываем локальную блокировку когда родитель сбросил свой флаг
    // (например, когда пользователь нажал "Нет" в диалоге или валидация не прошла)
    isLoading(newVal, oldVal) {
      console.log('ArrivalDialog watch: isLoading changed from', oldVal, 'to', newVal, ', isProcessingLocal:', this.isProcessingLocal);
      // Когда родитель завершил обработку (isLoading стал false), сбрасываем локальную блокировку
      if (newVal === false) {
        console.log('ArrivalDialog: isLoading became false, resetting isProcessingLocal');
        this.isProcessingLocal = false;
      }
    }
  }
}
</script>
